<template>
	<v-card>
		<v-dialog max-width="60vw" v-model="openUserInfosRequestData">
			<UserInfosRequestDataV2
				v-if="openUserInfosRequestData"
				@save="handleUser"
				:isSingleSelect="true"
				@close="onClose"
			></UserInfosRequestDataV2>
		</v-dialog>
		<v-toolbar>
			<v-toolbar-title>
				{{
					this.editedItem && this.editedItem.id
						? this.$t("label.edit_process_repeat")
						: this.$t("title.create_process_repeat")
				}}
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn icon @click="close('close')">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-toolbar>
		<v-card-text class="white mt-3">
			<v-row class="font-weight-black px-5 pb-2 pt-4"
				>Thiết lập thông tin quy trình
			</v-row>
			<v-row>
				<v-col>
					<v-text-field
						:label="$t('label.title')"
						v-model="m_editedItem.title"
						maxLength="255"
						dense
						outlined
						hide-details
					>
						<template v-slot:label>
							{{ $t("label.title") }}
							<span class="red--text">*</span>
						</template>
					</v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-text-field
						label="Tiêu đề Phiếu yêu cầu"
						v-model="m_editedItem.titlePYC"
						maxLength="255"
						dense
						outlined
						hide-details
					>
						<template v-slot:label>
							{{ "Tiêu đề Phiếu yêu cầu" }}
							<span class="red--text">*</span>
						</template>
					</v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-combobox
						v-model="m_editedItem.requestGroup"
						:items="listRequestGroup"
						item-text="requestGroupName"
						:item-value="(item) => item.id"
						:label="$t(`label.request_group`)"
						dense
						hide-details
						outlined
						clearable
						maxLength="255"
					>
						<template v-slot:label>
							{{ $t("label.request_group") }}
							<span class="red--text">*</span>
						</template>
					</v-combobox>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-combobox
						v-model="m_editedItem.typeGroup"
						:items="listTypeGroup"
						item-text="requestName"
						:item-value="(item) => item.id"
						:label="$t(`label.type_group`)"
						dense
						hide-details
						outlined
						clearable
						maxLength="255"
					>
						<template v-slot:label>
							{{ $t("label.type_group") }}
							<span class="red--text">*</span>
						</template>
					</v-combobox>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<tiptap-vuetify
						v-model="m_editedItem.description"
						:extensions="extensions"
						placeholder="Mô tả..."
						min-height="200"
						:card-props="{
							flat: true,
							outlined: true,
						}"
					/>
				</v-col>
			</v-row>
			<v-row @click="selectUser()">
				<v-col>
					<v-combobox
						v-model="m_editedItem.userId"
						item-text="fullName"
						clearable
						:label="$t(`label.created_name`)"
						dense
						hide-details
						outlined
						@click:clear="removeUser"
					>
						<template v-slot:selection="{ attrs, item }">
							<v-chip v-bind="attrs" class="mt-2">
								{{ item.fullName }}
							</v-chip>
						</template>
					</v-combobox>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-combobox
						v-model="repeatFrequency"
						:items="listRepeatFrequency"
						item-text="name"
						:label="$t(`label.repeat_frequency`)"
						return-object
						dense
						hide-details
						outlined
						clearable
						maxLength="255"
					>
						<template v-slot:label>
							{{ $t("label.repeat_frequency") }}
							<span class="red--text">*</span>
						</template>
					</v-combobox>
				</v-col>
			</v-row>
			<v-row v-if="repeatFrequency && repeatFrequency.id === 0">
				<v-col>
					<v-autocomplete
						v-model="repeatByWeek"
						:items="listDaysWeek"
						item-text="name"
						:item-value="(item) => item.id"
						label="Chọn các thứ lặp lại"
						dense
						hide-details
						outlined
						multiple
						clearable
						maxLength="255"
					>
						<template v-slot:label>
							{{ "Chọn các thứ lặp lại" }}
							<span class="red--text">*</span>
						</template>
					</v-autocomplete>
				</v-col>
			</v-row>

			<v-row v-else-if="repeatFrequency && repeatFrequency.id === 1">
				<v-col>
					<v-combobox
						v-model="repeatByMonth"
						:items="listDaysMonth"
						label="Chọn các ngày lặp lại"
						dense
						multiple
						hide-details
						outlined
						clearable
						maxLength="255"
					>
						<template v-slot:label>
							{{ "Chọn các ngày lặp lại" }}
							<span class="red--text">*</span>
						</template>
					</v-combobox>
				</v-col>
			</v-row>

			<v-row v-else-if="repeatFrequency && repeatFrequency.id === 2">
				<v-col>
					<v-menu
						ref="menu"
						v-model="menu"
						:close-on-content-click="false"
						:return-value.sync="repeatByYear"
						offset-y
						min-width="290"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-combobox
								multiple
								chips
								small-chips
								:value="formatSelectDateFns"
								append-icon="mdi-calendar"
								@click:clear="repeatByYear = null"
								readonly
								v-bind="attrs"
								v-on="on"
								clearable
								hide-details
								outlined
							>
								<template v-slot:label>
									Chọn các ngày tháng lặp lại
									<span class="text-red-600">{{
										$t("label.star")
									}}</span>
								</template>
							</v-combobox>
						</template>
						<v-date-picker
							v-model="repeatByYear"
							multiple
							no-title
							scrollable
						>
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="menu = false">
								Cancel
							</v-btn>
							<v-btn
								text
								:color="customColors['mbf-color-4']"
								@click="$refs.menu.save(repeatByYear)"
							>
								OK
							</v-btn>
						</v-date-picker>
					</v-menu>
				</v-col>
			</v-row>

			<v-row class="font-weight-black px-5 pb-2 pt-4"
				>Thời gian thiết lập
			</v-row>
			<v-row>
				<v-col>
					<m-date-picker
						label="Ngày bắt đầu"
						:value="m_editedItem.selectStartDate"
						@value="(v) => (m_editedItem.selectStartDate = v)"
						format="DD/MM/yyyy"
						:required="true"
					/>
				</v-col>
				<v-col>
					<m-date-picker
						label="Ngày kết thúc"
						:value="m_editedItem.selectEndDate"
						@value="(v) => (m_editedItem.selectEndDate = v)"
						format="DD/MM/yyyy"
						:required="false"
					/>
				</v-col>
			</v-row>
			<v-row>
				<!--				<v-col>-->
				<!--					<v-checkbox-->
				<!--						v-model="m_editedItem.createPYC"-->
				<!--						dense-->
				<!--						hide-details-->
				<!--						label="Tạo phiếu yêu cầu ngay"-->
				<!--					></v-checkbox>-->
				<!--				</v-col>-->
				<v-col>
					<v-checkbox
						v-model="m_editedItem.isMailSms"
						dense
						hide-details
						label="Gửi mail/sms thông báo"
					></v-checkbox>
				</v-col>
				<v-col>
					<v-checkbox
						v-model="m_editedItem.isActive"
						dense
						hide-details
						label="Được sử dụng"
					></v-checkbox>
				</v-col>
			</v-row>
		</v-card-text>

		<v-card-actions class="white mb-3">
			<v-spacer></v-spacer>
			<v-btn
				:color="customColors['mbf-color-4']"
				class="rounded-0"
				dark
				elevation="0"
				@click="save"
			>
				{{ $t("button.ok") }}
			</v-btn>
			<v-btn
				color="grey lighten-4"
				class="rounded-0"
				@click="close('close')"
				elevation="0"
			>
				{{ $t("button.close") }}
			</v-btn>
		</v-card-actions>
	</v-card>
</template>
<script>
import globalService from "@/services/global.service";
import administratorAPI from "../administrator.api";
import {
	TiptapVuetify,
	// Heading,
	Bold,
	Italic,
	Strike,
	Underline,
	Code,
	Paragraph,
	ListItem,
	Link,
	Blockquote,
	HardBreak,
	HorizontalRule,
	History,
	Image,
	Table,
	TableCell,
	TableHeader,
	TableRow,
} from "tiptap-vuetify";
import moment from "moment";
import UserInfosRequestDataV2 from "@/views/modules/khai-phieu-yeu-cau/RequestForm/UserInfosRequestDataV2";
// import constant from "@/common/constant";
// import RequestDataDto from "@/models/request-data.dto";
export default {
	name: "EditProcessStep",
	components: { TiptapVuetify, UserInfosRequestDataV2 },
	props: {
		editedItem: {},
		createdPyc: {
			type: Boolean,
			default: false,
		},
		idRequestGroup: null,
		idRequestType: null,
		requestData: null,
	},
	data() {
		return {
			menu: false,
			isCreatedPyc: false,
			listRequestGroup: [],
			listTypeGroup: [],
			startDate: false,
			endDate: false,
			selectStartDate: null,
			selectEndDate: null,
			stepNameMessage: "",
			descriptionMessage: "",
			processTermMessage: "",
			regex: /^[0-9]{1,2}(\.[0-9])?$/,
			listOrganzine: [],
			listRank: [],
			editedIndex: -1,
			listRepeatFrequency: [
				{ id: 0, name: "Hàng tuần " },
				{ id: 1, name: "Hàng tháng " },
				{ id: 2, name: "Hàng năm " },
			],
			listDaysWeek: [
				{ id: "2", name: "Thứ Hai " },
				{ id: "3", name: "Thứ Ba " },
				{ id: "4", name: "Thứ Tư " },
				{ id: "5", name: "Thứ Năm " },
				{ id: "6", name: "Thứ Sáu " },
				{ id: "7", name: "Thứ Bảy " },
				{ id: "8", name: "Chủ Nhật " },
			],
			listDaysMonth: [],
			selectRequestGroup: null,
			selectTypeGroup: null,
			processRepeatDTO: null,
			repeatByWeek: null,
			repeatByMonth: null,
			repeatByYear: null,
			m_editedItem: {
				title: "",
				titlePYC: "",
				requestGroup: null,
				typeGroup: null,
				description: null,
				userId: null,
				repeatFrequency: null,
				dayMonthYear: [],
				selectStartDate: null,
				selectEndDate: null,
				createPYC: false,
				isActive: true,
				isMailSms: false,
			},
			repeatFrequency: null,
			isSaving: false,
			errFormat: false,
			extensions: [
				History,
				Blockquote,
				Link,
				Underline,
				Strike,
				Italic,
				ListItem,
				Bold,
				Code,
				HorizontalRule,
				Paragraph,
				HardBreak,
				Image,
				Table,
				TableCell,
				TableHeader,
				TableRow,
			],
			requestType: null,
			requestGroup: null,
			openUserInfosRequestData: false,
		};
	},
	watch: {
		editedItem: {
			handler(value) {
				if (value && value.id) {
					this.repeatFrequency = this.listRepeatFrequency.find(
						(el) => el.id === value.repeatFrequency,
					);
					this.m_editedItem = value;
				}
			},
			immediate: true,
		},
		createdPyc(value) {
			this.isCreatedPyc = value;
		},
		repeatFrequency: {
			handler(val, oldVal) {
				if (val && !oldVal && this.editedItem) {
					if (val.id === 0) {
						this.repeatByWeek = this.editedItem.dayMonthYear;
					} else if (val.id === 1) {
						this.repeatByMonth = this.editedItem.dayMonthYear;
					} else if (val.id === 2) {
						this.repeatByYear = this.editedItem.dayMonthYear;
					}
					return;
				}
			},
			immediate: true,
		},

		requestGroup() {
			if (this.isCreatedPyc && this.requestGroup) {
				this.m_editedItem.requestGroup = this.listRequestGroup.find(
					(item) => item?.id === this.requestGroup,
				);
			}
		},

		repeatByYear(value) {
			this.m_editedItem.dayMonthYear = value;
		},
		"m_editedItem.requestGroup"() {
			this.getRequestTypeByid();
		},
	},
	created() {
		this.initialize();
	},
	computed: {
		formatSelectDateFns() {
			if (!this.repeatByYear) {
				return null;
			}
			const dates11 = this.repeatByYear.map((dateString) => {
				const date = new Date(dateString);
				const day = date.getDate().toString().padStart(2, "0");
				const month = (date.getMonth() + 1).toString().padStart(2, "0");
				return `${day}-${month}`;
			});
			// eslint-disable-next-line vue/no-side-effects-in-computed-properties

			return dates11;
		},
	},
	methods: {
		async initialize() {
			await this.getRequestGroup();
			// this.m_editedItem = this.editedItem;
			this.isCreatedPyc = this.createdPyc;

			if (!this.editedItem?.id) {
				this.m_editedItem.userId = this.currentUserInfo;
			} else {
				this.m_editedItem.userId = this.editedItem.userId;
			}
			this.requestType = this.idRequestType;
			this.m_editedItem.titlePYC = this.requestData?.title
				? this.requestData.title
				: "";
			this.m_editedItem.description = this.requestData?.description
				? this.requestData.description
				: "";
			this.requestGroup = this.idRequestGroup;

			for (let i = 1; i <= 31; i++) {
				this.listDaysMonth.push(i.toString());
			}
			await this.getRequestTypes();
		},
		async getRequestTypeByid() {
			await this.getRequestTypes();
			if (
				this.isCreatedPyc &&
				this.requestType &&
				this.listTypeGroup.length > 0
			) {
				this.m_editedItem.typeGroup = this.listTypeGroup.find(
					(item) => item?.requestTypeId === this.requestType,
				);
			}
		},

		async getRequestGroup() {
			try {
				const response = await globalService.getData_Async(
					administratorAPI.API_GetAllRequestGroupV2(),
				);
				if (!response.state) {
					return;
				}
				this.listRequestGroup = response.data
					.filter((entry) => {
						return !entry.isDelete && entry.isActive;
					})
					.sort(function (a, b) {
						if (a?.requestGroupName < b?.requestGroupName) {
							return -1;
						}
						if (a?.requestGroupName > b?.requestGroupName) {
							return 1;
						}
						return 0;
					});
			} catch (error) {
				console.log(error);
			}
		},
		async getRequestTypes() {
			let response;
			try {
				response = await globalService.getData_Async(
					administratorAPI.API_GetRequestByRequestGroupIdV3(
						this.m_editedItem?.requestGroup?.id,
						this.currentUserInfo?.organizations[0].id,
					),
				);
				if (!response?.state || !response?.data?.length > 0) {
					return [];
				}
				this.listTypeGroup = response.data.filter((entry) => {
					return !entry.isDelete && entry.isActive;
				});
				return this.sortList(this.listTypeGroup);
			} catch (error) {
				this.toastError(error);
				return [];
			}
		},

		close(value) {
			this.$emit("close", value);
		},
		checkNotNullOrEmpty(input) {
			return input !== null && input !== "" && input !== undefined;
		},
		validateConfig() {
			console.log("this.m_editedItem", this.m_editedItem);
			const validateTitle = this.checkNotNullOrEmpty(
				this.m_editedItem.title,
			);
			if (!validateTitle) {
				this.toastError("Yêu cầu điền đầy đủ tên cấu hình");
				return false;
			}
			const validateRequestGroup = this.checkNotNullOrEmpty(
				this.m_editedItem.requestGroup,
			);
			const validateTitlePYc = this.checkNotNullOrEmpty(
				this.m_editedItem.titlePYC,
			);
			if (!validateTitlePYc) {
				this.toastError("Yêu cầu điền đầy đủ tên Phiếu yêu cầu");
				return false;
			}
			if (!validateRequestGroup) {
				this.toastError("Yêu cầu chọn nhóm yêu cầu");
				return false;
			}
			const validateTypeGroup = this.checkNotNullOrEmpty(
				this.m_editedItem.typeGroup,
			);

			if (!validateTypeGroup) {
				this.toastError("Yêu cầu chọn loại yêu cầu");
				return false;
			}
			const validateCreatedName = this.checkNotNullOrEmpty(
				this.m_editedItem.userId,
			);

			if (!validateCreatedName) {
				this.toastError("Yêu cầu ten người tạo");
				return false;
			}
			const validateRepeatFrequency = this.checkNotNullOrEmpty(
				this.m_editedItem.repeatFrequency,
			);

			if (!validateRepeatFrequency) {
				this.toastError("Yêu cầu chọn tần suất lặp");
				return false;
			}

			const validateMonthYear = this.checkNotNullOrEmpty(
				this.m_editedItem.dayMonthYear,
			);

			if (!validateMonthYear) {
				this.toastError("Yêu cầu chọn thời gian lặp ");
				return false;
			}

			const validateSelectStartDate = this.checkNotNullOrEmpty(
				this.m_editedItem.selectStartDate,
			);

			if (!validateSelectStartDate) {
				this.toastError("Yêu cầu chọn ngày bắt đầu");
				return false;
			}
			return true;
		},

		selectUser() {
			this.openUserInfosRequestData = true;
		},
		async removeUser() {
			this.m_editedItem.userId = null;
		},

		handleUser(val) {
			this.m_editedItem.userId = val[0];
		},

		onClose(value) {
			if (value) {
				this.openUserInfosRequestData = false;
			}
		},

		processDayMonthYearValue() {
			if (this.repeatFrequency?.id === 0) {
				return this.repeatByWeek;
			} else if (this.repeatFrequency?.id === 1) {
				return this.repeatByMonth;
			} else if (this.repeatFrequency?.id === 2) {
				return this.repeatByYear;
			}
		},

		async save() {
			if (this.repeatFrequency !== null) {
				this.m_editedItem.repeatFrequency = this.repeatFrequency.id;
			}
			this.m_editedItem.dayMonthYear = this.processDayMonthYearValue();
			if (this.validateConfig()) {
				let response;
				if (!this.editedItem?.id) {
					try {
						response = await globalService.postData_Async(
							administratorAPI.API_CreateRequestDataLoop(),
							this.m_editedItem,
						);

						if (!response.state) {
							return this.toastError(response.message);
						}
						this.$emit("save", {
							...this.m_editedItem,
							id: response.data.id,
						});
						this.toastSuccess("Tạo quy trình lặp thành công");
					} catch (error) {
						this.toastError(error);
						return;
					}
				}
				if (this.editedItem?.id) {
					let response;
					try {
						response = await globalService.putData_Async(
							administratorAPI.API_UpdateRequestDataLoop(
								this.editedItem.id,
							),
							this.m_editedItem,
						);

						if (!response.state) {
							return this.toastError(response.message);
						}
						this.$emit("save", {
							...this.m_editedItem,
							id: response.data.id,
						});
						this.toastSuccess("Cập nhật quy trình lặp thành công");
					} catch (error) {
						this.toastError(error);
						return;
					}
				}
				this.$emit("reload", true);
				this.close("close");
			}
		},
		sortList(arr) {
			return arr.sort((a, b) => {
				return (
					moment(b.createdDate).toDate().getTime() -
					moment(a.createdDate).toDate().getTime()
				);
			});
		},
	},
};
</script>
<style>
.text {
	font-size: 16px;
	font-weight: 500;
}
</style>
